import React from "react";
import Grid from "@mui/material/Grid";
import {Chip, Paper, TextField, Typography} from "@mui/material";
import Box from "@mui/material/Box";

interface EmailListPreviewProps {
    f,
    onChange: (value: string[]) => void,
    datum: string[]
}

export const EmailListPreview = ({f, onChange, datum}: EmailListPreviewProps) => {
    const [textValue, setTextValue] = React.useState(
        Array.isArray(datum) ? datum.join(", ") : datum ?? ""
    )

    function getValueArray(valueString) {
        return valueString
            .split(/[,\n\r\s]+/)
            .map((value) => value.trim())
            .filter((value) => value.length > 0 && value.includes('@'));
    }

    const stringArray = getValueArray(textValue)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setTextValue(value)

        const completedValues = getValueArray(value)
        onChange(completedValues)
    }

    return (
        <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} md={6}>
                <TextField
                    data-testid={`textarea-${f.key.toString()}`}
                    value={textValue}
                    onChange={handleChange}
                    required={f.required}
                    disabled={f.disabled}
                    multiline
                    minRows={8}
                    fullWidth
                    label={f.label}
                    variant="outlined"
                    name={f.label}
                    placeholder="Type email addresses separated by commas, spaces, or new lines..."
                    InputProps={{
                        sx: {
                            fontFamily: 'monospace',
                            fontSize: '0.875rem',
                            height: '100%',
                            alignItems: 'stretch',
                        },
                    }}
                    sx={{height: '100%'}}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <Paper
                    variant="outlined"
                    sx={{
                        p: 2,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'grey.50',
                    }}
                >
                    <Typography variant="subtitle2" gutterBottom sx={{flexShrink: 0}}>
                        Preview ({stringArray.length} emails):
                    </Typography>

                    <Box>
                        {stringArray.map((value, index) => (
                            <Chip
                                data-testid={`email-chip-${index}`}
                                key={index}
                                label={value}
                                size="small"
                                variant="outlined"
                                sx={{
                                    fontSize: '0.75rem',
                                    fontFamily: 'monospace',
                                    height: 'fit-content',
                                }}
                            />
                        ))}
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    )
};